<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Análise de indicações</mat-card-title>
    </mat-card-header>

    <div class="filter">
      <div class="row">
        <form
          [formGroup]="doctorForm"
          class="col-xl-9 col-lg-8 col-md-6 col-sm-12"
        >
          <div class="doctor">
            <mat-form-field appearance="outline">
              <mat-label>Médicos</mat-label>

              <mat-select multiple formControlName="id">
                <mat-option
                  *ngFor="let doctor of doctorOptions"
                  [value]="doctor.id"
                >
                  {{ doctor.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>

        <form
          [formGroup]="schedulesForm"
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
        >
          <mat-form-field appearance="outline">
            <mat-label>Data do agendamento</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Data inicial"
                formControlName="dateFrom"
              />
              <input
                matEndDate
                placeholder="Data final"
                formControlName="dateTo"
              />
            </mat-date-range-input>

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </form>
      </div>

      <div class="row actions">
        <button
          class="col-2"
          mat-flat-button
          aria-label="Limpar Filtros"
          type="button"
          (click)="clearFilter()"
        >
          <span>Limpar Filtros</span>
        </button>

        <button
          class="col-2"
          mat-raised-button
          color="primary"
          aria-label="Buscar"
          type="button"
          (click)="onSearch()"
        >
          <fa-icon icon="search"></fa-icon>
          <span>Pesquisar</span>
        </button>
      </div>
    </div>

    <ng-container
      *ngIf="dataSource.data.length; then table; else noContentOrLoading"
    ></ng-container>
  </mat-card>
</app-ui-main-menu>

<ng-template #table>
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-table col-xl-12 col-lg-12 col-md-12 col-sm-12"
  >
    <ng-container matColumnDef="indicationStatus">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">{{ row.status }}</td>
    </ng-container>

    <ng-container matColumnDef="accountName">
      <th mat-header-cell *matHeaderCellDef>Escritório</th>
      <td mat-cell *matCellDef="let row">{{ row.user.account.name }}</td>
    </ng-container>

    <ng-container matColumnDef="scheduleDoctorName">
      <th mat-header-cell *matHeaderCellDef>Médico</th>
      <td mat-cell *matCellDef="let row">
        {{ row.schedules[0]?.doctor?.name ?? "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="scheduleDate">
      <th mat-header-cell *matHeaderCellDef>Data Consulta</th>
      <td mat-cell *matCellDef="let row">
        {{ row.schedules[0]?.date ? (row.schedules[0]?.date | date) : "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="indicationDocumentUrl">
      <th mat-header-cell *matHeaderCellDef>Laudo</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row?.hasActiveDocument; else noLaudo">
          <mat-icon color="primary">check</mat-icon>
        </ng-container>
        <ng-template #noLaudo>-</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="transactionAmount">
      <th mat-header-cell *matHeaderCellDef>Valor Consulta</th>
      <td mat-cell *matCellDef="let row">
        {{
          row.transactions[0]?.amount
            ? (row.transactions[0]?.amount | currency)
            : "-"
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="transactionAddress">
      <th mat-header-cell *matHeaderCellDef>Faturamento</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.transactions[0]?.addressId; else noAddress">
          <mat-icon color="primary">check</mat-icon>
        </ng-container>
        <ng-template #noAddress>-</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="invoiceId">
      <th mat-header-cell *matHeaderCellDef>Nota Fiscal</th>

      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.invoice?.nfeId; else dash">
          <a
            [href]="generateInvoiceLink(row.invoice?.nfeId!)"
            target="_blank"
            rel="noopener"
            style="text-decoration: none"
          >
            {{ generateInvoiceId(row.invoice?.nfeId) }}
          </a>
        </ng-container>
        <ng-template #dash>-</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="invoiceStatus">
      <th mat-header-cell *matHeaderCellDef>Nota Status</th>
      <td mat-cell *matCellDef="let row">
        {{ row.invoice?.statusNf ?? "-" }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
  </table>

  <mat-paginator
    [length]="total"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50, 100, 500]"
    (page)="onSearch($event)"
  >
  </mat-paginator>
</ng-template>

<ng-template #noContentOrLoading>
  <div class="no-content" *ngIf="!isLoading">Nenhuma indicação encontrada!</div>
  <div class="loading" *ngIf="isLoading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>
